import {EntryData, Status} from "../../Types/entryData";
import React, {useRef, useState} from 'react';
import styled from "styled-components";
import {useFormik} from "formik";
import useAddEntry from "../../Hooks/useAddNewEntry";
import {formSchema} from "./formValidation";
import ImagesModal, {DisplayImg, Image, ImageContent} from "./ImagesModal";
import Reaptcha from 'reaptcha';

const FormWrap = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12% 10% 0 10%;
  position: relative;
  width: 100vw;


  p {
    font-size: 9px;
    padding: 0;
    margin: 0;
    font-family: Lato;
  }

  input {
    width: 190px;
    padding: 6px;
    margin: 10px;
    margin-right: 20px;
  }

  select {
    width: 218px;
    padding: 6px;
    margin: 10px;
    margin-right: 20px;
  }

  h1 {
    font-family: Lato;
    color: #E44432;
    font-weight: 800;
    margin-top: 10px;
    padding: 10px;
    border-radius: 50px;
  }

  label {
    font-family: Lato;
    font-weight: 400;
    margin-right: 6px;
    width: 100px;
    margin-bottom: 15px;

    @media (max-width: 768px) {
      margin: 0;
      padding: 0;
      width: auto;
    }


  }

  #extended {
    width: auto;
    margin: 0 0 10px 0;
    font-size: 14px;
    @media (max-width: 768px) {

      padding: 20px;

    }

  }


  input[type='button'] {
    background-color: #E44432;
    color: white;
    font-weight: 600;
    font-size: 20px;
    max-width: 300px;
    border: none;
    padding: 15px;
    margin-top: 40px;
    border-radius: 15px;
    align-self: center;

    :hover {
      background-color: #88281c;
    }
  }


  button {
    background-color: #E44432;
    color: white;
    font-weight: 600;
    font-size: 20px;
    max-width: 300px;
    border: none;
    padding: 15px;
    margin-top: 40px;
    border-radius: 15px;
    align-self: center;

    :hover {
      background-color: #88281c;
    }
  }

  input[type='checkbox'] {
    margin: 0 0 10px 0;
    padding: 0;
    justify-self: left;
  }

  form {
    display: flex;
    flex-direction: column;
    max-width: 750px;
  }

  @media (max-width: 768px) {
    width: 100vw;
  }
`
const ErrorDiv = styled.div`
  color: red;
`
const InputPair = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const RulesText = styled.div`
  margin: 15px 0;


  @media (max-width: 768px) {
    margin: 0;
    padding: 30px;
    width: 320px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;

  @media (max-width: 768px) {
    width: 100vw;
  }
`


const Captcha = styled.div`
  display: flex;
  justify-content: center;
  align-items: center`

const FormEnglish = () => {

        const [imgUrls, setImgUrls] = useState<string[] | null>(null);
        const [imgModal, setImgModal] = useState(false);
        const [captchaToken, setCaptchaToken] = useState(null);
        const captchaRef = useRef(null);

        const {addNewEntry} = useAddEntry(imgUrls);

        const verify = () => {
            // @ts-ignore
            captchaRef.current!.getResponse().then((res: React.SetStateAction<null>) => {
                setCaptchaToken(res)
            })

        }

        const submitEntryHandler = async (values: EntryData) => {
            const {success: addedEntrySuccesfully} = await addNewEntry(
                {
                    ...values,
                });
            if (addedEntrySuccesfully === true) {
                alert('Thank you for your entry');
            } else {
                console.log('Error!')
            }
        }


        const formik = useFormik({
            initialValues: {
                name: '',
                surname: '',
                email: '',
                country: '',
                university: '',
                status: Status.STUDENT,
                yearGraduated: '',
                rules: false,
                statement: false,
            },

            validationSchema: formSchema,
            onSubmit: (values: EntryData) => {
                submitEntryHandler(values)
            },
        });

        return (
            <FormWrap>
                <Content>
                    <h1>Add Submition</h1>
                    <form onSubmit={formik.handleSubmit}>
                        <InputPair>
                            <label htmlFor="name">Name</label>
                            <input
                                id="name"
                                name="name"
                                type="text"
                                onChange={formik.handleChange}
                                value={formik.values.name}
                                style={{
                                    backgroundColor: formik.touched.name && formik.errors.name ? "#FFD8C9" : "",
                                    color: formik.touched.name && formik.errors.name ? "red" : ""
                                }}
                            />
                            {formik.touched.name && formik.errors.name ? (
                                <ErrorDiv>{formik.errors.name}</ErrorDiv>
                            ) : null}

                            <label htmlFor="surname">Surname</label>
                            <input
                                id="surname"
                                name="surname"
                                type="text"
                                onChange={formik.handleChange}
                                value={formik.values.surname}
                                style={{
                                    backgroundColor: formik.touched.surname && formik.errors.surname ? "#FFD8C9" : "",
                                    color: formik.touched.surname && formik.errors.surname ? "red" : ""
                                }}
                            />
                            {formik.touched.surname && formik.errors.surname ? (
                                <ErrorDiv>{formik.errors.surname}</ErrorDiv>
                            ) : null}
                        </InputPair>

                        <InputPair>
                            <label htmlFor="email">Email</label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                onChange={formik.handleChange}
                                value={formik.values.email}
                                style={{
                                    backgroundColor: formik.touched.email && formik.errors.email ? "#FFD8C9" : "",
                                    color: formik.touched.email && formik.errors.email ? "red" : ""
                                }}
                            />
                            {formik.touched.email && formik.errors.email ? (
                                <ErrorDiv>{formik.errors.email}</ErrorDiv>
                            ) : null}
                        </InputPair>

                        <InputPair>
                            <label htmlFor="country"> Country </label>
                            <select
                                id="country"
                                name="country"
                                onChange={formik.handleChange}
                                value={formik.values.country}>
                                <option>Wybierz Kraj</option>
                                <option value="Afghanistan">Afghanistan</option>
                                <option value="Aland Islands">Åland Islands</option>
                                <option value="Albania">Albania</option>
                                <option value="Algeria">Algeria</option>
                                <option value="American Samoa">American Samoa</option>
                                <option value="Andorra">Andorra</option>
                                <option value="Angola">Angola</option>
                                <option value="Anguilla">Anguilla</option>
                                <option value="Antarctica">Antarctica</option>
                                <option value="Antigua and Barbuda">Antigua & Barbuda</option>
                                <option value="Argentina">Argentina</option>
                                <option value="Armenia">Armenia</option>
                                <option value="Aruba">Aruba</option>
                                <option value="Australia">Australia</option>
                                <option value="Austria">Austria</option>
                                <option value="Azerbaijan">Azerbaijan</option>
                                <option value="Bahamas">Bahamas</option>
                                <option value="Bahrain">Bahrain</option>
                                <option value="Bangladesh">Bangladesh</option>
                                <option value="Barbados">Barbados</option>
                                <option value="Belarus">Belarus</option>
                                <option value="Belgium">Belgium</option>
                                <option value="Belize">Belize</option>
                                <option value="Benin">Benin</option>
                                <option value="Bermuda">Bermuda</option>
                                <option value="Bhutan">Bhutan</option>
                                <option value="Bolivia">Bolivia</option>
                                <option value="Bonaire, Sint Eustatius and Saba">Caribbean Netherlands</option>
                                <option value="Bosnia and Herzegovina">Bosnia & Herzegovina</option>
                                <option value="Botswana">Botswana</option>
                                <option value="Bouvet Island">Bouvet Island</option>
                                <option value="Brazil">Brazil</option>
                                <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                <option value="Brunei Darussalam">Brunei</option>
                                <option value="Bulgaria">Bulgaria</option>
                                <option value="Burkina Faso">Burkina Faso</option>
                                <option value="Burundi">Burundi</option>
                                <option value="Cambodia">Cambodia</option>
                                <option value="Cameroon">Cameroon</option>
                                <option value="Canada">Canada</option>
                                <option value="Cape Verde">Cape Verde</option>
                                <option value="Cayman Islands">Cayman Islands</option>
                                <option value="Central African Republic">Central African Republic</option>
                                <option value="Chad">Chad</option>
                                <option value="Chile">Chile</option>
                                <option value="China">China</option>
                                <option value="Christmas Island">Christmas Island</option>
                                <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                                <option value="Colombia">Colombia</option>
                                <option value="Comoros">Comoros</option>
                                <option value="Congo">Congo - Brazzaville</option>
                                <option value="Congo, Democratic Republic of the Congo">Congo - Kinshasa</option>
                                <option value="Cook Islands">Cook Islands</option>
                                <option value="Costa Rica">Costa Rica</option>
                                <option value="Cote D'Ivoire">Côte d’Ivoire</option>
                                <option value="Croatia">Croatia</option>
                                <option value="Cuba">Cuba</option>
                                <option value="Curacao">Curaçao</option>
                                <option value="Cyprus">Cyprus</option>
                                <option value="Czech Republic">Czechia</option>
                                <option value="Denmark">Denmark</option>
                                <option value="Djibouti">Djibouti</option>
                                <option value="Dominica">Dominica</option>
                                <option value="Dominican Republic">Dominican Republic</option>
                                <option value="Ecuador">Ecuador</option>
                                <option value="Egypt">Egypt</option>
                                <option value="El Salvador">El Salvador</option>
                                <option value="Equatorial Guinea">Equatorial Guinea</option>
                                <option value="Eritrea">Eritrea</option>
                                <option value="Estonia">Estonia</option>
                                <option value="Ethiopia">Ethiopia</option>
                                <option value="Falkland Islands (Malvinas)">Falkland Islands (Islas Malvinas)</option>
                                <option value="Faroe Islands">Faroe Islands</option>
                                <option value="Fiji">Fiji</option>
                                <option value="Finland">Finland</option>
                                <option value="France">France</option>
                                <option value="French Guiana">French Guiana</option>
                                <option value="French Polynesia">French Polynesia</option>
                                <option value="French Southern Territories">French Southern Territories</option>
                                <option value="Gabon">Gabon</option>
                                <option value="Gambia">Gambia</option>
                                <option value="Georgia">Georgia</option>
                                <option value="Germany">Germany</option>
                                <option value="Ghana">Ghana</option>
                                <option value="Gibraltar">Gibraltar</option>
                                <option value="Greece">Greece</option>
                                <option value="Greenland">Greenland</option>
                                <option value="Grenada">Grenada</option>
                                <option value="Guadeloupe">Guadeloupe</option>
                                <option value="Guam">Guam</option>
                                <option value="Guatemala">Guatemala</option>
                                <option value="Guernsey">Guernsey</option>
                                <option value="Guinea">Guinea</option>
                                <option value="Guinea-Bissau">Guinea-Bissau</option>
                                <option value="Guyana">Guyana</option>
                                <option value="Haiti">Haiti</option>
                                <option value="Heard Island and Mcdonald Islands">Heard & McDonald Islands</option>
                                <option value="Holy See (Vatican City State)">Vatican City</option>
                                <option value="Honduras">Honduras</option>
                                <option value="Hong Kong">Hong Kong</option>
                                <option value="Hungary">Hungary</option>
                                <option value="Iceland">Iceland</option>
                                <option value="India">India</option>
                                <option value="Indonesia">Indonesia</option>
                                <option value="Iran, Islamic Republic of">Iran</option>
                                <option value="Iraq">Iraq</option>
                                <option value="Ireland">Ireland</option>
                                <option value="Isle of Man">Isle of Man</option>
                                <option value="Israel">Israel</option>
                                <option value="Italy">Italy</option>
                                <option value="Jamaica">Jamaica</option>
                                <option value="Japan">Japan</option>
                                <option value="Jersey">Jersey</option>
                                <option value="Jordan">Jordan</option>
                                <option value="Kazakhstan">Kazakhstan</option>
                                <option value="Kenya">Kenya</option>
                                <option value="Kiribati">Kiribati</option>
                                <option value="Korea, Democratic People's Republic of">North Korea</option>
                                <option value="Korea, Republic of">South Korea</option>
                                <option value="Kosovo">Kosovo</option>
                                <option value="Kuwait">Kuwait</option>
                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                <option value="Lao People's Democratic Republic">Laos</option>
                                <option value="Latvia">Latvia</option>
                                <option value="Lebanon">Lebanon</option>
                                <option value="Lesotho">Lesotho</option>
                                <option value="Liberia">Liberia</option>
                                <option value="Libyan Arab Jamahiriya">Libya</option>
                                <option value="Liechtenstein">Liechtenstein</option>
                                <option value="Lithuania">Lithuania</option>
                                <option value="Luxembourg">Luxembourg</option>
                                <option value="Macao">Macao</option>
                                <option value="Macedonia, the Former Yugoslav Republic of">North Macedonia</option>
                                <option value="Madagascar">Madagascar</option>
                                <option value="Malawi">Malawi</option>
                                <option value="Malaysia">Malaysia</option>
                                <option value="Maldives">Maldives</option>
                                <option value="Mali">Mali</option>
                                <option value="Malta">Malta</option>
                                <option value="Marshall Islands">Marshall Islands</option>
                                <option value="Martinique">Martinique</option>
                                <option value="Mauritania">Mauritania</option>
                                <option value="Mauritius">Mauritius</option>
                                <option value="Mayotte">Mayotte</option>
                                <option value="Mexico">Mexico</option>
                                <option value="Micronesia, Federated States of">Micronesia</option>
                                <option value="Moldova, Republic of">Moldova</option>
                                <option value="Monaco">Monaco</option>
                                <option value="Mongolia">Mongolia</option>
                                <option value="Montenegro">Montenegro</option>
                                <option value="Montserrat">Montserrat</option>
                                <option value="Morocco">Morocco</option>
                                <option value="Mozambique">Mozambique</option>
                                <option value="Myanmar">Myanmar (Burma)</option>
                                <option value="Namibia">Namibia</option>
                                <option value="Nauru">Nauru</option>
                                <option value="Nepal">Nepal</option>
                                <option value="Netherlands">Netherlands</option>
                                <option value="Netherlands Antilles">Curaçao</option>
                                <option value="New Caledonia">New Caledonia</option>
                                <option value="New Zealand">New Zealand</option>
                                <option value="Nicaragua">Nicaragua</option>
                                <option value="Niger">Niger</option>
                                <option value="Nigeria">Nigeria</option>
                                <option value="Niue">Niue</option>
                                <option value="Norfolk Island">Norfolk Island</option>
                                <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                <option value="Norway">Norway</option>
                                <option value="Oman">Oman</option>
                                <option value="Pakistan">Pakistan</option>
                                <option value="Palau">Palau</option>
                                <option value="Palestinian Territory, Occupied">Palestine</option>
                                <option value="Panama">Panama</option>
                                <option value="Papua New Guinea">Papua New Guinea</option>
                                <option value="Paraguay">Paraguay</option>
                                <option value="Peru">Peru</option>
                                <option value="Philippines">Philippines</option>
                                <option value="Pitcairn">Pitcairn Islands</option>
                                <option value="Poland">Poland</option>
                                <option value="Portugal">Portugal</option>
                                <option value="Puerto Rico">Puerto Rico</option>
                                <option value="Qatar">Qatar</option>
                                <option value="Reunion">Réunion</option>
                                <option value="Romania">Romania</option>
                                <option value="Russian Federation">Russia</option>
                                <option value="Rwanda">Rwanda</option>
                                <option value="Saint Barthelemy">St. Barthélemy</option>
                                <option value="Saint Helena">St. Helena</option>
                                <option value="Saint Kitts and Nevis">St. Kitts & Nevis</option>
                                <option value="Saint Lucia">St. Lucia</option>
                                <option value="Saint Martin">St. Martin</option>
                                <option value="Saint Pierre and Miquelon">St. Pierre & Miquelon</option>
                                <option value="Saint Vincent and the Grenadines">St. Vincent & Grenadines</option>
                                <option value="Samoa">Samoa</option>
                                <option value="San Marino">San Marino</option>
                                <option value="Sao Tome and Principe">São Tomé & Príncipe</option>
                                <option value="Saudi Arabia">Saudi Arabia</option>
                                <option value="Senegal">Senegal</option>
                                <option value="Serbia">Serbia</option>
                                <option value="Serbia and Montenegro">Serbia</option>
                                <option value="Seychelles">Seychelles</option>
                                <option value="Sierra Leone">Sierra Leone</option>
                                <option value="Singapore">Singapore</option>
                                <option value="Sint Maarten">Sint Maarten</option>
                                <option value="Slovakia">Slovakia</option>
                                <option value="Slovenia">Slovenia</option>
                                <option value="Solomon Islands">Solomon Islands</option>
                                <option value="Somalia">Somalia</option>
                                <option value="South Africa">South Africa</option>
                                <option value="South Georgia and the South Sandwich Islands">South Georgia & South Sandwich
                                    Islands
                                </option>
                                <option value="South Sudan">South Sudan</option>
                                <option value="Spain">Spain</option>
                                <option value="Sri Lanka">Sri Lanka</option>
                                <option value="Sudan">Sudan</option>
                                <option value="Suriname">Suriname</option>
                                <option value="Svalbard and Jan Mayen">Svalbard & Jan Mayen</option>
                                <option value="Swaziland">Eswatini</option>
                                <option value="Sweden">Sweden</option>
                                <option value="Switzerland">Switzerland</option>
                                <option value="Syrian Arab Republic">Syria</option>
                                <option value="Taiwan, Province of China">Taiwan</option>
                                <option value="Tajikistan">Tajikistan</option>
                                <option value="Tanzania, United Republic of">Tanzania</option>
                                <option value="Thailand">Thailand</option>
                                <option value="Timor-Leste">Timor-Leste</option>
                                <option value="Togo">Togo</option>
                                <option value="Tokelau">Tokelau</option>
                                <option value="Tonga">Tonga</option>
                                <option value="Trinidad and Tobago">Trinidad & Tobago</option>
                                <option value="Tunisia">Tunisia</option>
                                <option value="Turkey">Turkey</option>
                                <option value="Turkmenistan">Turkmenistan</option>
                                <option value="Turks and Caicos Islands">Turks & Caicos Islands</option>
                                <option value="Tuvalu">Tuvalu</option>
                                <option value="Uganda">Uganda</option>
                                <option value="Ukraine">Ukraine</option>
                                <option value="United Arab Emirates">United Arab Emirates</option>
                                <option value="United Kingdom">United Kingdom</option>
                                <option value="United States">United States</option>
                                <option value="United States Minor Outlying Islands">U.S. Outlying Islands</option>
                                <option value="Uruguay">Uruguay</option>
                                <option value="Uzbekistan">Uzbekistan</option>
                                <option value="Vanuatu">Vanuatu</option>
                                <option value="Venezuela">Venezuela</option>
                                <option value="Viet Nam">Vietnam</option>
                                <option value="Virgin Islands, British">British Virgin Islands</option>
                                <option value="Virgin Islands, U.s.">U.S. Virgin Islands</option>
                                <option value="Wallis and Futuna">Wallis & Futuna</option>
                                <option value="Western Sahara">Western Sahara</option>
                                <option value="Yemen">Yemen</option>
                                <option value="Zambia">Zambia</option>
                                <option value="Zimbabwe">Zimbabwe</option>
                            </select>


                            <label htmlFor="university">University</label>
                            <input
                                id="university"
                                name="university"
                                type="university"
                                onChange={formik.handleChange}
                                value={formik.values.university}
                                style={{
                                    backgroundColor: formik.touched.university && formik.errors.university ? "#FFD8C9" : "",
                                    color: formik.touched.university && formik.errors.university ? "red" : ""
                                }}
                            />
                            {formik.touched.university && formik.errors.university ? (
                                <ErrorDiv>{formik.errors.university}</ErrorDiv>
                            ) : null}
                        </InputPair>
                        <InputPair>
                            <label htmlFor="status"> Status </label>
                            <select
                                id="status"
                                name="status"
                                onChange={formik.handleChange}
                                value={formik.values.status}>
                                <option value="">Pick Status</option>
                                <option value={Status.STUDENT}>Student</option>
                                <option value={Status.ALUMNUS}>Graduate</option>
                            </select>


                            <label htmlFor="graduationDate">Graduation year </label>
                            <input
                                id="graduationDate"
                                name="graduationDate"
                                type="number"
                                min="1980"
                                max="2023"
                            />
                        </InputPair>

                        <input id="images"
                               name="images"
                               type="button"
                               value="Add Posters"
                               onClick={() => setImgModal(true)}/>


                        {imgModal && <ImagesModal imgUrls={imgUrls} setImgUrls={setImgUrls} setImgModal={setImgModal}/>}


                        <ImageContent>
                            {imgUrls?.map((url) => {
                                return <DisplayImg key={Math.random()}>
                                    <Image src={url}/>
                                </DisplayImg>
                            })
                            }
                        </ImageContent>


                        <InputPair>
                            <label id="extended" htmlFor="rules">I declare that I have read the Rules and accept their provisions</label>
                            <input id="rules"
                                   name="rules"
                                   type="checkbox"
                            />

                            {formik.touched.rules && formik.errors.rules ? (
                                <ErrorDiv>{formik.errors.rules}</ErrorDiv>
                            ) : null}
                        </InputPair>

                        <InputPair>
                            <label id="extended" htmlFor="statement"> Participant's declaration on privacy policy and RODO</label>
                            <input id="statement"
                                   name="statement"
                                   type="checkbox"
                                   value="false"
                            />
                            {formik.touched.statement && formik.errors.statement ? (
                                <ErrorDiv>{formik.errors.statement}</ErrorDiv>
                            ) : null}
                        </InputPair>


                        <RulesText>
                            <p>DECLARATION OF THE COMPETITION PARTICIPANT</p>
                            <p> (information obligation in connection with Articles 13 and 14 of the Regulation (EU) No
                                2016/679
                                of the European
                                Parliament and of the Council in connection with joining the Competition entitled:
                                Competition for a poster: 550th birthday of Nicolaus Copernicus / (hereinafter referred to
                                as
                                the Competition)</p>
                            <p> I acknowledge that:
                            </p>
                            <p> 1. The University of Warmia and Mazury in Olsztyn, Michała Oczapowskiego 2, 10-719 Olsztyn,
                                Poland is the administrator of my personal data.</p>
                            <p> 2. The processing of my personal data is lawful and meets the conditions referred to in art.
                                6 clause 1 letter c and art. 9 item 2 letter g of Regulation (EU) 2016/679 of the European
                                Parliament and of the Council – personal data is necessary for my participation in the
                                Competition.</p>
                            <p> 3. My personal data has been entrusted for processing to entities that participate in the
                                implementation of the Competition.</p>
                            <p> 4. My consent to the processing of personal data as part of the Competition means that I
                                agree to the processing of my data in advertising, information and promotional activities
                                related to the Competition.</p>
                            <p> 5. Providing data is a prerequisite for participation in the Competition, and refusal to
                                provide it is tantamount to being unable to participate or receive the prize.</p>
                            <p> 6. In order to participate in the Competition, the following personal data will be
                                processed: given name (names), surname, name of the university, year of graduation, e-mail
                                address and image.</p>
                            <p> 7. The processing of my personal data is legal and meets the conditions referred to in
                                Regulation (EU) 2016/679 of the European Parliament and of the Council.</p>
                            <p> 8. My personal data will not be subject to automated decision making, including decisions
                                based on profiling.</p>
                            <p> 9. My personal data will be stored until the end of the Competition, and if I receive the
                                prize until it is collected (completed).</p>
                            <p> 10. I can contact the UWM data protection officer by sending a message to the e-mail
                                address: bkw@uwm.edu.pl</p>
                            <p> 11. In the event that the processing of personal data violates the provisions on the
                                protection of personal data, I have the right to lodge a complaint to the President of the
                                Office for Personal Data Protection (address: https://uodo.gov.pl/pl/p/kontakt ).</p>
                            <p> 12. In connection with the processing of my data, I have the right to:</p>
                            <p> 1) access the content of personal data, including obtaining a copy of the data,</p>
                            <p> 2) request rectification or supplementation of personal data,</p>
                            <p> 3) request removal of personal data in cases provided for by law,</p>
                            <p> 4) request restriction of data processing,</p>
                            <p> 5) object to the processing,</p>
                            <p>6) transfer data,</p>
                            <p>7) withdraw consent to the processing of personal data at any time without affecting the
                                lawfulness of the processing that was carried out on the basis of consent before its
                                withdrawal.</p>
                        </RulesText>

                        <Captcha>
                            <Reaptcha
                                sitekey={'6LdXdu4kAAAAADYfnJzgk44izNipsiCXOQWRIYfh'}
                                ref={captchaRef}
                                onVerify={verify}
                            />
                        </Captcha>

                        {
                            (captchaToken === null) ? <button type="submit" disabled>Submit</button> :
                                <button type="submit">Submit</button>
                        }
                    </form>
                </Content>
            </FormWrap>
        )
    }
;
export default FormEnglish




















